module.exports = __webpack_public_path__ + "img/poster-1.b371b3ed.jpg";